<div id="node-container" tabindex="0">
    <div class="title" data-testid="title">{{ data.label }}</div>
    <div class="node-content">
        <div class="data">
            @for (workflowData of workflowTriggerData | keyvalue; track $index) {
                <div class="property">
                    <span class="property-label">{{ workflowData.key }} :</span>
                    <span class="property-value">{{ workflowTriggerData[workflowData.key] }}</span>
                </div>
            }
        </div>
        <div class="outputs">
            <div class="output" *ngFor="let output of data.outputs | keyvalue: sortByIndex" [attr.data-testid]="'output-' + output.key">
                <div
                    class="output-socket"
                    refComponent
                    [data]="{ type: 'socket', side: 'output', key: output.key, nodeId: data.id, payload: output.value?.socket, seed: seed }"
                    [emit]="emit"
                    data-testid="output-socket"></div>
                <div class="output-title" data-testid="output-title">
                    {{ output.value?.label }}
                </div>
            </div>
        </div>
    </div>
</div>
